export default __webpack_public_path__ + "static/media/soundboardthumbnail.7930970b.png";